/**
 * @generated SignedSource<<30e7bff7501ed85c1ada0a9e7a961b83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewNew_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewNew_fragmentRef";
};
export type cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewNew_fragmentRef$key = {
  readonly " $data"?: cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewNew_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewNew_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewNew_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "cascadingSelect_issueFieldCascadingSelectInlineEditFull_CascadingSelectInlineEditViewIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraCascadingSelectField"
};

(node as any).hash = "e7ecd450fd47d2261ef09c2802d1bf69";

export default node;
